<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="设置管理"></el-page-header>
        <el-form label-width="240px" class="form"
                 style="width: 60%;margin: 20px auto 0 auto;min-width: 580px;" autocomplete="off" label-position="left">
            <el-form-item label="后台apk最新版本">
                <el-input class="input" v-model="admin_version" placeholder="请输入后台apk最新版本" style="width: 20%; !important;"
                          autocomplete="off" @blur="feedChange"></el-input>
            </el-form-item>
            <el-form-item label="特属服务对象服务费">
                <el-input class="input" v-model="service_fee" placeholder="请输入服务费" style="width: 20%; !important;"
                          autocomplete="off" @blur="feedChange"></el-input>
                <span style="float: left;">元</span>
            </el-form-item>
            <el-form-item label="特属服务对象服务费市场价">
                <el-input class="input" v-model="market_price" placeholder="请输入服务费市场价" style="width: 20%; !important;"
                          autocomplete="off" @blur="priceChange"></el-input>
                <span style="float: left;">元</span>
            </el-form-item>
            <p  class="notice" style="width: calc(20% + 210px); !important;">特属服务对象每年支付的费用</p>
            <el-form-item label="续约提醒">
                <el-input class="input" type="number" v-model="remind_days" placeholder="请输入续约提醒"
                          autocomplete="off" ></el-input>
                <span style="float: left;">天</span>
            </el-form-item>
            <p  class="notice">低于阀值时出现在续约报表</p>
            <el-form-item label="健康档案密码设置提醒周期">
                <el-input class="input" type="number" v-model="secure_set_remind_days" placeholder="请输入时间周期"
                          autocomplete="off" ></el-input>
                <span style="float: left;">天</span>
            </el-form-item>
            <el-form-item label="开启专家库安全密码" v-if="role_id == 1" style="width: 30% !important;">
                <el-switch v-model="expert_pwd_set">
                </el-switch>
            </el-form-item>
            <el-form-item label="专家库安全密码" v-if="role_id == 1 && expert_pwd_set">
                <el-input class="input" type="password" v-model="expert_pwd" placeholder="请输入专家库安全密码"
                          autocomplete="off" ></el-input>
            </el-form-item>
            <el-form-item label="客服电话1">
                <el-input class="input" type="number" v-model="consumer_hotline1" placeholder="请输入客服电话" autocomplete="off"
                          ></el-input>
            </el-form-item>
            <el-form-item label="客服电话2">
                <el-input class="input" type="number" v-model="consumer_hotline2" placeholder="请输入客服电话" autocomplete="off"
                          ></el-input>
            </el-form-item>
            <el-form-item label="预约单响应时间频率">
                <el-input class="input" type="number" v-model="user_manage_deal_expired_time" min="0" placeholder="请输入服务专员响应时间频率"
                          ></el-input>
                <span style="float: left;">分钟</span>
            </el-form-item>
             <p class="notice">超过阀值时预约状态转为未响应</p>
            <el-form-item label="预约单语音通知次数">
                <el-input class="input" type="number" v-model="voice_times" min="0" placeholder="请输入语音通知次数"
                          ></el-input>
            </el-form-item>
            <p  class="notice">为0时不发送语音通知</p>
            <el-form-item label="预约单语音通知时间间隔">
                <el-input class="input" type="number" v-model="voice_time" min="0" placeholder="请输入语音通知时间间隔"
                          ></el-input>
                <span style="float: left;">分钟</span>
            </el-form-item>
            <p  class="notice" >为0时不发送语音通知</p>
            <el-form-item label="留言语音通知时间间隔">
                <el-input class="input" type="number" v-model="chat_voice_time" min="0" placeholder="请输入留言语音通知时间间隔"
                ></el-input>
                <span style="float: left;">分钟</span>
            </el-form-item>
            <p  class="notice" >对象留言未收到专家回复的时长，为0时不发送语音通知</p>
            <el-form-item label="留言语音通知次数">
                <el-input class="input" type="number" v-model="chat_voice_times" min="0" placeholder="请输入留言语音通知次数"
                ></el-input>
            </el-form-item>
            <p  class="notice">专家未回复留言，语音通知专员的次数上限，为0时不发送语音通知</p>
            <el-form-item label="留言再次语音通知时间间隔">
                <el-input class="input" type="number" v-model="chat_revoice_time" min="0" placeholder="请输入留言二次语音通知时间间隔"
                ></el-input>
                <span style="float: left;">分钟</span>
            </el-form-item>
            <p  class="notice" >专员接通语音通知后再次语音通知的时间间隔，为0时接通后不再发送语音通知</p>
            <el-form-item label="留言再次语音通知次数">
                <el-input class="input" type="number" v-model="chat_revoice_times" min="0" placeholder="请输入留言二次语音通知时间间隔"
                ></el-input>
            </el-form-item>
            <p  class="notice" >专员接通语音通知次数上限，为0时接通后不再发送语音通知</p>
            <el-form-item label="特属服务对象预约提醒时间">
                <el-input class="input" type="number" v-model="remind_hours" min="0" placeholder="请输入特属服务对象预约提醒时间"
                          autocomplete="off" ></el-input>
                <span style="float: left;">小时</span>
            </el-form-item>
            <p  class="notice">距离预约时间倒数的小时</p>
            <el-form-item label="超时未回复消息提醒时间">
                <el-input class="input" type="number" v-model="doctor_reply_time" min="0" placeholder="请输入超时未回复消息提醒时间"
                          ></el-input>
                <span style="float: left;">分钟</span>
            </el-form-item>
            <p  class="notice">特属专家超过提醒时间未回复特属服务对象，发送消息提醒通知后台和特属专家</p>

            <el-form-item label="特属服务对象聊天提醒，时长">
                <el-input class="input" type="number" v-model="user_chat_time" min="0" placeholder="请输入聊天提醒时长时间"
                          ></el-input>
                <span style="float: left;">分钟</span>
            </el-form-item>
            <el-form-item label="特属服务对象聊天提醒，消息数">
                <el-input class="input" type="number" v-model="user_chat_frequency" min="0" placeholder="请输入聊天提醒频率"
                          ></el-input>
                <span style="float: left;">条</span>
            </el-form-item>
            <p class="notice">特属服务对象与特属专家在提醒时长时间范围内，双方聊天消息数达到设置消息数发出提醒</p>
            <el-form-item label="聊天消息撤回时间限制">
                <el-input class="input" type="number" v-model="chat_recall_time" min="0" placeholder="请输入聊天提醒频率"
                          ></el-input>
                <span style="float: left;">分钟</span>
            </el-form-item>
            <p class="notice">发出的消息在未超过设置的时间范围内可撤回</p>
            <el-form-item label="健康档案未更新提醒时间">
                <el-input class="input" type="number" v-model="healthrecord_timeout" min="0" placeholder="请输入健康档案未更新提醒时间"
                          ></el-input>
                <span style="float: left;">小时</span>
            </el-form-item>
            <p class="notice">会面完成后超过此时间会在档案未更新列表展示</p>
            <div>
                <div style="float: left;margin-bottom: 10px;width: 200px;text-align: right;">
                    <label class="el-form-item__label" style="width: 240px;">服务专员客服</label>
                </div>
                <div style="float: left;width: calc(100% - 240px);margin-left: 40px;">
                    <div style="margin-bottom: 10px;width: 25%;text-align: left;">
                        <el-button class="el-button el-button--primary" @click="addUser" style="width: 100% !important;">添加服务专员</el-button>
                    </div>
                    <div v-for="(user, index) in operate_users">
                        <div style="float: left;width: 25%;margin-bottom: 5px;">
                            <el-select v-model="user.group_id" @change="changeGroup(index, user.group_id)" placeholder="请选择运营负责组"
                                       style="width: 100%;">
                                <el-option
                                    v-for="item in allCompanyGroup"
                                    :key="item.id"
                                    :label="item.group_name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </div>
                        <div style="float: left;margin-left: 1%;width: 39%;margin-bottom: 5px;">
                            <el-select v-model="user.operate_user_id"
                                       placeholder="请选择服务专员"
                                       style="width: 100%;">
                                <el-option
                                    v-for="item in allGroupUser"
                                    :key="item.id"
                                    :label="item.operate_user_name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </div>
                        <div style="float: left;margin-left: 1%;width: 25%;margin-bottom: 5px;">
                            <el-input type="text" v-model="user.nick_name" placeholder="请输入客服名称" autocomplete="off"
                                      style="width: 100%;"></el-input>
                        </div>
                        <div class="delete_icon" style="float: left;margin-left: 1%;width:8%;margin-bottom: 5px;">
                            <el-button type="danger" icon="el-icon-delete" circle @click="delItem(index)"></el-button>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <!-- form表单提交 -->
            <el-form-item style="clear: both;">
                <el-button type="success" @click="submitForm()">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import Env from "@/api/env";

    export default {
        mounted() {
            let user_info = getUserInfos();
            if (user_info) {
                this.role_id = user_info.role_id
            }

            if ((Env.MODE_ENV && Env.MODE_ENV === 'admin') || Env.MODE_ENV === 'local') {
                this.is_product = true
            }

            this.getSystemSetDetail();
            this.getAllCompanyGroup()
            localStorage.setItem('prev_page', 'system_list')
        },
        data() {
            return {
                role_id: '',
                consumer_hotline1: '',
                consumer_hotline2: '',
                remind_days: '',
                service_fee: '',
                market_price: '',
                secure_set_remind_days: '',
                expert_pwd: '',
                expert_pwd_set: false,
                user_manage_contract_right:false,
                user_manage_healthrecord_right:false,
                user_manage_deal_expired_time:'',
                voice_times:0,
                voice_time:0,
                remind_hours: '',
                doctor_reply_time: '',
                user_chat_frequency: 0,
                user_chat_time: 0,
                chat_recall_time: 0,
                healthrecord_timeout: 0,
                expert_pwd_is_set: false, // 是否已设置专家库安全密码
                is_submit: false,
                operate_users:[],
                allCompany: [],
                allCompanyDeparment: [],
                allCompanyGroup: [],
                allGroupUser: [],
                is_product: false,
                admin_version: '',
                chat_voice_time:0,
                chat_voice_times:0,
                chat_revoice_time:0,
                chat_revoice_times:0,
            };
        },
        methods: {
            addUser() {
                this.operate_users.push({
                    id: 0,
                    company_id: 18,
                    department_id: 15,
                    group_id: '',
                    operate_user_id: '',
                    nick_name: '',
                })
            },
            delItem(index) {
                this.operate_users.splice(index, 1)
            },
            // 详情
            getSystemSetDetail() {
                let params = {
                    'servername': 'Ruyi_AdminSystemServices',
                    'method': 'systemSetDetail'
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    if (res.data.data) {
                        if (res.data.data.consumer_hotline) {
                            this.consumer_hotline1 = res.data.data.consumer_hotline[0];
                            this.consumer_hotline2 = res.data.data.consumer_hotline[1];
                        }
                        if (res.data.data.remind_days) {
                            this.remind_days = res.data.data.remind_days;
                        }
                        if (res.data.data.secure_set_remind_days) {
                            this.secure_set_remind_days = res.data.data.secure_set_remind_days;
                        }
                        if (res.data.data.healthrecord_timeout) {
                            this.healthrecord_timeout = res.data.data.healthrecord_timeout;
                        }
                        if (this.role_id == 1) {
                            if (res.data.data.expert_pwd_set == 1) {
                                this.expert_pwd_set = true;
                            }
                            if (res.data.data.expert_pwd) {
                                this.expert_pwd_is_set = true;
                            }
                        }

                        if (res.data.data.user_manage_contract_right) {
                            this.user_manage_contract_right = res.data.data.user_manage_contract_right==1?true:false;
                        }
                        if (res.data.data.user_manage_healthrecord_right) {
                            this.user_manage_healthrecord_right = res.data.data.user_manage_healthrecord_right==1?true:false;
                        }
                        if (res.data.data.user_manage_deal_expired_time) {
                            this.user_manage_deal_expired_time = res.data.data.user_manage_deal_expired_time;
                        }
                        if (res.data.data.remind_hours) {
                            this.remind_hours = res.data.data.remind_hours;
                        }
                        if (res.data.data.doctor_reply_time) {
                            this.doctor_reply_time = res.data.data.doctor_reply_time;
                        }
                        if (res.data.data.user_chat_frequency) {
                            this.user_chat_frequency = res.data.data.user_chat_frequency;
                        }
                        if (res.data.data.user_chat_time) {
                            this.user_chat_time = res.data.data.user_chat_time;
                        }
                        if (res.data.data.chat_recall_time) {
                            this.chat_recall_time = res.data.data.chat_recall_time;
                        }
                        // 预约预约通知配置
                        if (res.data.data.voice_times) {
                            this.voice_times = res.data.data.voice_times;
                        }
                        if (res.data.data.voice_time) {
                            this.voice_time = res.data.data.voice_time;
                        }

                        // 留言语音通知配置
                        if (res.data.data.chat_voice_time) {
                            this.chat_voice_time = res.data.data.chat_voice_time;
                        }
                        if (res.data.data.chat_voice_times) {
                            this.chat_voice_times = res.data.data.chat_voice_times;
                        }
                        if (res.data.data.chat_revoice_time) {
                            this.chat_revoice_time = res.data.data.chat_revoice_time;
                        }
                        if (res.data.data.chat_revoice_times) {
                            this.chat_revoice_times = res.data.data.chat_revoice_times;
                        }

                        if (res.data.data.service_fee) {
                            this.service_fee = Number(res.data.data.service_fee).toFixed(2);
                        }
                        if (res.data.data.market_price) {
                            this.market_price = Number(res.data.data.market_price).toFixed(2);
                        }
                        this.admin_version = res.data.data.admin_version
                        if (res.data.data.operate_users) {
                            let users = res.data.data.operate_users
                            this.operate_users = [];
                            for (let i = 0; i < users.length; i++) {
                                this.operate_users.push({
                                    id: users[i].id,
                                    company_id: users[i].company_id,
                                    department_id: users[i].department_id,
                                    group_id: users[i].group_id,
                                    nick_name: users[i].nick_name,
                                    operate_user_id: users[i].operate_user_id,
                                    operate_user_name: `${users[i].operate_user_name}(${users[i].operate_user_mobile})`,
                                })
                                this.changeGroup(i, users[i].group_id)
                            }
                        }
                    }
                });
            },


            // 返回上一页
            goBack() {
                window.history.go(-1);
            },
            feedChange() {
                this.service_fee = Number(this.service_fee).toFixed(2)
            },
            priceChange() {
                this.market_price = Number(this.market_price).toFixed(2)
            },
            // 提交表单
            submitForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (this.role_id == 1 && this.expert_pwd_set == 1) {
                    if (!this.expert_pwd && !this.expert_pwd_is_set) {
                        this.$message({
                            type: "error",
                            message: '请输入专家库安全密码！',
                            duration: 1000,
                        });
                        this.is_submit = false;
                        return;
                    }
                    if (!this.expert_pwd_is_set && !(/^[0-9a-zA-Z_@]{6,16}$/).test(this.expert_pwd)) {
                        this.$message({
                            type: "error",
                            message: '安全密码可由数字、字母和下划线组成，长度6-16位',
                            duration: 1000,
                        });
                        this.is_submit = false;
                        return;
                    }

                }
                let params = {
                    'servername': 'Ruyi_AdminSystemServices',
                    'method': 'systemSet',
                    'params': {
                        consumer_hotline: [this.consumer_hotline1, this.consumer_hotline2],
                        remind_days: this.remind_days,
                        secure_set_remind_days: this.secure_set_remind_days,
                        expert_pwd: this.expert_pwd,
                        expert_pwd_set: this.expert_pwd_set ? 1 : 2,
                        user_manage_contract_right: this.user_manage_contract_right?1:2,
                        user_manage_healthrecord_right:this.user_manage_healthrecord_right?1:2,
                        user_manage_deal_expired_time:this.user_manage_deal_expired_time,
                        remind_hours:this.remind_hours,
                        doctor_reply_time: this.doctor_reply_time,
                        user_chat_frequency: this.user_chat_frequency,
                        user_chat_time: this.user_chat_time,
                        chat_recall_time: this.chat_recall_time,
                        voice_time: this.voice_time,
                        voice_times: this.voice_times,
                        healthrecord_timeout: this.healthrecord_timeout,
                        service_fee: this.service_fee,
                        market_price: this.market_price,
                        operate_users: this.operate_users,
                        admin_version: this.admin_version,
                        chat_voice_time: this.chat_voice_time,
                        chat_voice_times: this.chat_voice_times,
                        chat_revoice_time: this.chat_revoice_time,
                        chat_revoice_times: this.chat_revoice_times,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: '设置错误'
                        });
                    } else {
                        this.expert_pwd = '';
                        this.$message({
                            type: "success",
                            message: '设置成功',
                        });
                        if (this.expert_pwd_set == 1 && this.expert_pwd) {
                            localStorage.removeItem('expert_pwd'); // 清除缓存密码
                        }
                        this.expert_pwd_is_set = true
                        this.getSystemSetDetail();
                    }
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            getAllCompanyGroup() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyGroup',
                    params: {
                        company_id: 18,
                        department_id: 15,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompanyGroup = res.data.data;
                });
            },
            // 获取组成员
            changeGroup(index, group_id) {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllGroupUser',
                    params: {
                        company_id: 18,
                        department_id: 15,
                        group_id: group_id,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    let users = res.data.data
                    this.allGroupUser = []
                    if (users) {
                        for (let i = 0; i < users.length; i++) {
                            this.allGroupUser.push({
                                id: users[i].id,
                                company_id: users[i].company_id,
                                department_id: users[i].department_id,
                                group_id: users[i].group_id,
                                operate_user_name: `${users[i].user_name}(${users[i].mobile})`,
                            })
                        }
                    }
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }
    .device-type-add {
        .form {
            transform: translateX(-6em);
            .notice {
                transform: translateY(-20px);
                color: #da0404;
                font-size: 12px !important;
                text-align: right;
                margin-right: 16em;
                width: calc(20% + 225px) !important;
            }
            .input {
                width: calc(100% - 12em) !important;
                float: left;
            }
            .el-form-item__label{
                font-weight: bold;
                text-align: right;
                transform: translateX(-2em);
            }

        }
    }
    .delete_icon {
        .el-icon-delete{
            transform: translate(-7px, -12px);
        }
        .is-circle{
            width: 24px !important;
            height: 24px !important;
            line-height: 24px !important;
        }
    }
    .device-type-add .form .input {
        width: 25% !important;
    }

</style>
